import { render } from "./candidates-kanban.vue?vue&type=template&id=5eb2ab26"
import script from "./candidates-kanban.vue?vue&type=script&lang=js"
export * from "./candidates-kanban.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__